var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakeholderVarianceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.552,
    height: 22.81,
    viewBox: "0 0 24.552 22.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    width: 24.552,
    height: 22.81,
    fill: "#ebf8ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5377",
    "data-name": "Path 5377",
    d: "M21.858,13.21a5.115,5.115,0,0,0-2.267-.6l-.139,0h0a5.064,5.064,0,0,0-3.923,1.845l-2.522-1.457V10.168A5.1,5.1,0,0,0,15.7,1.189a5.1,5.1,0,1,0-3.851,8.979V13L9.1,14.585a5.085,5.085,0,1,0,.6.988L12.429,14l2.465,1.424a5.1,5.1,0,1,0,6.964-2.211m-2.406,6.343h.009A3.916,3.916,0,0,1,22.133,20.6a3.943,3.943,0,0,1-5.362,0,3.921,3.921,0,0,1,2.681-1.043m-2.134-5.165a3.933,3.933,0,0,1,2.131-.626h.006a3.941,3.941,0,0,1,3.4,5.93,5.085,5.085,0,0,0-3.4-1.3h-.009a5.076,5.076,0,0,0-3.4,1.3,3.946,3.946,0,0,1,1.271-5.3m-4.89-8.6h-.009a5.074,5.074,0,0,0-3.4,1.3,3.941,3.941,0,0,1,3.4-5.93h.007a3.941,3.941,0,0,1,3.4,5.93,5.084,5.084,0,0,0-3.4-1.3m2.681,2.2a3.9,3.9,0,0,1-2.679,1.054h0A3.9,3.9,0,0,1,9.748,7.992,3.924,3.924,0,0,1,12.43,6.949h.008A3.919,3.919,0,0,1,15.11,7.992m-6.636,11.7a5.086,5.086,0,0,0-3.4-1.3H5.06a5.075,5.075,0,0,0-3.4,1.3,3.946,3.946,0,0,1,3.4-5.936,3.991,3.991,0,0,1,.847.091,3.944,3.944,0,0,1,2.566,5.844m-.724.9a3.943,3.943,0,0,1-5.362,0,3.919,3.919,0,0,1,2.681-1.043h.009A3.917,3.917,0,0,1,7.749,20.6",
    transform: "translate(0 0)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5378",
    "data-name": "Path 5378",
    d: "M40.121,7.4a1.772,1.772,0,1,0,1.772,1.772A1.774,1.774,0,0,0,40.121,7.4m0,2.388h0a.616.616,0,0,1-.616-.616.616.616,0,1,1,.616.616",
    transform: "translate(-27.692 -5.341)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5379",
    "data-name": "Path 5379",
    d: "M65.392,56.3a1.772,1.772,0,0,0,0-3.544h0a1.772,1.772,0,1,0,0,3.544m.615-1.772a.616.616,0,1,1-.615-.616.616.616,0,0,1,.615.616",
    transform: "translate(-45.94 -38.094)",
    fill: "#ebf8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5380",
    "data-name": "Path 5380",
    d: "M13.637,52.753h0a1.772,1.772,0,0,0,0,3.544h0a1.772,1.772,0,0,0,0-3.544m-.616,1.772a.616.616,0,1,1,.616.616.616.616,0,0,1-.616-.616",
    transform: "translate(-8.569 -38.094)",
    fill: "#ebf8ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeholderVarianceLight);
export default __webpack_public_path__ + "static/media/stakeholder_variance_light.7d4c14d3491bde6db1fe22050d6700e1.svg";
export { ForwardRef as ReactComponent };